// Lib
import React from 'react';
import { useTranslator } from '../../../components/i18n/useTranslator';

/**
 * This component is used when the element does not exist / could not be retrieved for that user.
 */
const NotFoundElementModal = () => {
    const translate = useTranslator('modal', 'element.notFound');

    return (
        <div className="NotFoundElementModal">
            <h2>{translate('title')}</h2>
            <div>
                <p>{translate('message')}</p>
            </div>
        </div>
    );
};

NotFoundElementModal.propTypes = {};

export default NotFoundElementModal;
